import React, { useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { IoIosArrowBack } from 'react-icons/io'
import '../styles/legal.css'

const LINKS = [
  { to: '/about-us', label: 'About' },
  { to: '/policy', label: 'Privacy' },
  { to: '/contact-us', label: 'Contact' },
  { to: '/career', label: 'Careers' }
]

const LegalPage = ({
  title,
  heading,
  description,
  children
}) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const bodyRef = useRef(null)

  useEffect(() => {
    const root = bodyRef.current
    if (!root) return undefined
    const items = root.querySelectorAll('.legalRise')
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('isIn')
      })
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' })
    items.forEach((item) => {
      io.observe(item)
      const box = item.getBoundingClientRect()
      if (box.top < window.innerHeight * 0.92) item.classList.add('isIn')
    })
    return () => io.disconnect()
  }, [pathname])

  return (
    <section className="legalPage">
      <Helmet>
        <title>{title}</title>
        <meta name="theme-color" content="#000000" />
        <meta name="description" content={description} />
        <link rel="canonical" href={`https://pinweelo.com${pathname}`} />
      </Helmet>

      <header className="legalTop">
        <button
          type="button"
          className="legalBack"
          onClick={() => {
            if (window.history.length > 1) navigate(-1)
            else navigate('/')
          }}
          aria-label="Go back"
        >
          <IoIosArrowBack />
        </button>
        <h1>{heading}</h1>
        <span className="legalTopSpace" aria-hidden="true" />
      </header>

      <div className="legalBody" ref={bodyRef}>
        {children}
        <nav className="legalLinks legalRise" aria-label="Site info">
          {LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={pathname === link.to ? 'isCurrent' : undefined}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </section>
  )
}

export default LegalPage
